import request from "api/request";

export const fetchCallSlots = (mentorshipId, auth) => request({
  url: `api/v3/mentorships/${mentorshipId}/call-slots/`,
  method: 'GET',
  auth,
});

export const addCallSlot = (mentorshipId, slot, auth) => request({
  url: `api/v3/mentorships/${mentorshipId}/call-slots/`,
  method: 'POST',
  data: slot,
  auth,
});

export const removeCallSlot = (mentorshipId, slotId, auth) => request({
  url: `api/v3/mentorships/${mentorshipId}/call-slots/${slotId}/`,
  method: 'DELETE',
  auth,
});

export const fetchSuggestedCallTimes = (mentorshipId, auth) => request({
  url: `api/v3/mentorships/${mentorshipId}/suggested-call-times/?count=3`,
  method: 'GET',
  auth,
});

// Unlike saveEvent, scheduled_time goes out byte-for-byte: the backend matches
// it against the slot it suggested, offset included.
export const bookSuggestedCall = (mentorshipId, event, auth) => request({
  url: `api/v2/mentorships/${mentorshipId}/calendar-events/`,
  method: 'POST',
  data: {...event, mentorship: mentorshipId},
  auth,
});
